import React from 'react';

interface GameStatsProps {
    score: number;
    level: number;
    lives: number;
}

const GameStats: React.FC<GameStatsProps> = ({ score, level, lives }) => {
    return (
        <div style={{
            position: 'absolute',
            top: '200px',
            right: '140px',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            padding: '15px',
            background: 'linear-gradient(135deg, rgba(47,27,20,0.9) 0%, rgba(139,69,19,0.8) 50%, rgba(210,180,140,0.7) 100%)',
            borderRadius: '10px',
            // border: '2px solid #FFD700',
            boxShadow: '0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(255,215,0,0.3)',
            animation: 'statsGlow 2s ease-in-out infinite alternate',
            minWidth: '180px',
            textAlign: 'left'
        }}>
            <div style={{
                color: '#FFD700',
                fontWeight: 'bold',
                marginBottom: '10px',
                textAlign: 'center',
                fontSize: '16px',
                textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
            }}>
                🏆 DESERT STATS
            </div>

            <div style={{
                color: '#F4E4BC',
                fontSize: '15px',
                lineHeight: '1.4'
            }}>
                <div style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(255,215,0,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(255,215,0,0.3)'
                }}>
                    💎 Score: <span style={{
                        color: '#FFD700',
                        textShadow: '0 0 10px rgba(255,215,0,0.8)',
                        animation: 'scoreGlow 1.5s ease-in-out infinite alternate'
                    }}>
                        {score.toLocaleString()}
                    </span>
                </div>

                <div style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(50,205,50,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(50,205,50,0.3)'
                }}>
                    🏜️ Level: <span style={{
                        color: '#32CD32',
                        textShadow: '0 0 10px rgba(50,205,50,0.8)',
                        animation: 'levelGlow 1.5s ease-in-out infinite alternate'
                    }}>
                        {level}
                    </span>
                </div>

                <div style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(255,107,53,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(255,107,53,0.3)'
                }}>
                    ❤️ Lives: <span style={{
                        color: '#FF6B35',
                        textShadow: '0 0 10px rgba(255,107,53,0.8)',
                        animation: 'livesGlow 1.5s ease-in-out infinite alternate'
                    }}>
                        {'♥'.repeat(lives)}
                    </span>
                </div>
            </div>

            <style>{`
                @keyframes statsGlow {
                    0% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(255,215,0,0.3); }
                    100% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 25px rgba(255,215,0,0.5); }
                }
                
                @keyframes scoreGlow {
                    0% { text-shadow: 0 0 10px rgba(255,215,0,0.8); }
                    100% { text-shadow: 0 0 20px rgba(255,215,0,1); }
                }
                
                @keyframes levelGlow {
                    0% { text-shadow: 0 0 10px rgba(50,205,50,0.8); }
                    100% { text-shadow: 0 0 20px rgba(50,205,50,1); }
                }
                
                @keyframes livesGlow {
                    0% { text-shadow: 0 0 10px rgba(255,107,53,0.8); }
                    100% { text-shadow: 0 0 20px rgba(255,107,53,1); }
                }
            `}</style>
        </div>
    );
};

export default GameStats; 